import { render, staticRenderFns } from "./time-info.vue?vue&type=template&id=55b08114"
import script from "./time-info.vue?vue&type=script&lang=js"
export * from "./time-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports